import { render, staticRenderFns } from "./index.v2.vue?vue&type=template&id=21eb4a4e&scoped=true"
import script from "./index.v2.vue?vue&type=script&lang=js"
export * from "./index.v2.vue?vue&type=script&lang=js"
import style0 from "./index.v2.vue?vue&type=style&index=0&id=21eb4a4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb4a4e",
  null
  
)

export default component.exports